import { connect } from 'react-redux';
import { loginAction, logoutAction } from '@smorder/logic';

import MessageListener from './message-listener';

import { navigate } from '../../reducers/navigator.reducers';
import {
  selectLocation, selectReport, removeReportData, loadAllReportData, loadLocationsAction,
} from '../../reducers/reports.reducers';
import {
  setDateRange, setComparisonDateRange, removeComparisonDateRange, setFilterOption,
} from '../../reducers/filter.reducers';

import {
  setDialogOpen
} from '../../reducers/note.reducers';

const mapStateToProps = state => ({
  selectedLocation: state.reports.selectedLocation,
  selectedReport: state.reports.selectedReport,
  comparisonOptions: state.filter.comparisonOptions,
  daytimeOptions: state.filter.daytimeOptions,
  debug: state.app.debug,
});

const mapDispatchToProps = dispatch => ({
  loginSucceeded: payload => dispatch(loginAction.DONE(payload)),
  logout: () => dispatch(logoutAction()),
  navigate: destination => dispatch(navigate(destination)),
  selectLocation: locationId => dispatch(selectLocation(locationId)),
  selectReport: reportId => dispatch(selectReport(reportId)),
  setDateRange: dateRange => dispatch(setDateRange(dateRange)),
  setComparisonDateRange: startAndEndDate => dispatch(setComparisonDateRange(startAndEndDate)),
  removeComparisonDateRange: comparisonId => dispatch(removeComparisonDateRange(comparisonId)),
  removeReportData: comparisonId => dispatch(removeReportData(comparisonId)),
  setFilterOption: filterOption => dispatch(setFilterOption(filterOption)),
  loadAllReportData: () => dispatch(loadAllReportData()),
  openNoteDialog: () => dispatch(setDialogOpen(true)),
  loadLocations: () => dispatch(loadLocationsAction.INIT()),
});

export default connect(mapStateToProps, mapDispatchToProps)(MessageListener);
